import { useQuery } from '@apollo/client';
import { LoadingOrError } from '@retainerclub/common';
import { GET_PRODUCTION_ORDERS } from '@retainerclub/customer-api';
import { CustomerCard } from '@retainerclub/customer-shared';
import { useAuth } from '@retainerclub/hooks';
import DashboardShipmentsTable from './DashboardShipmentsTable';

function DashboardShipments() {
  const { currentUser } = useAuth();

  const { data, loading, error, refetch } = useQuery(GET_PRODUCTION_ORDERS, {
    skip: currentUser === null || currentUser === undefined,
  });

  const shipments = data?.productionOrders ?? [];

  const shouldRender = LoadingOrError({
    loading,
    error,
    title: 'Shipments',
  });

  if (shouldRender) {
    return (
      <CustomerCard
        title="Shipments"
        description={
          <span className="italic">
            Your shipments of retainers.
            <br />
            *When shown, estimated delivery dates are estimates and may change.
          </span>
        }
      >
        <DashboardShipmentsTable shipments={shipments} refetch={refetch} />
      </CustomerCard>
    );
  }

  return shouldRender;
}

export default DashboardShipments;
